class DynamicStyleWrapper {
  getStatusColor = (status: string) => {
    switch (status) {
      case 'Não preenchido':
        return 'gray'

      case 'Preenchido':
        return 'blue'

      case 'Em análise':
        return 'yellow'

      case 'Com pendências':
        return 'red'

      case 'Aprovado':
        return 'green'

      case 'Reprovado':
        return 'red'

      default:
        return 'gray'
    }
  }

  getStatusIcon = (status: string) => {
    switch (status) {
      case 'Não preenchido':
        return 'fa-minus-circle'

      case 'Preenchido':
        return 'fa-check-circle'

      case 'Em análise':
        return 'fa-pause-circle'

      case 'Com pendências':
        return 'fa-exclamation-circle'

      case 'Aprovado':
        return 'fa-check-circle'

      case 'Reprovado':
        return 'fa-exclamation-circle'

      default:
        return 'gray'
    }
  }
}

const DynamicStyle = new DynamicStyleWrapper();

export default DynamicStyle;
